import { render, staticRenderFns } from "./SplaLicenses.vue?vue&type=template&id=7c14de02&"
import script from "./SplaLicenses.vue?vue&type=script&lang=js&"
export * from "./SplaLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports